var _rect, _circle, _text, _line, _line2, _line3, _rect2, _text2, _rect3, _text3, _rect4, _text4, _line4, _line5, _line6, _line7, _line8, _line9, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _text5, _text6, _text7, _text8, _text9, _text10, _text11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSherlocRuleEngine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sherlockGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2d1a4d",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4d2d6f",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#sherlockGrad)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 50,
    r: 20,
    fill: "none",
    stroke: "#a78bfa",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 56,
    textAnchor: "middle",
    fontSize: 11,
    fill: "#a78bfa",
    fontWeight: "bold"
  }, "RULE")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 70,
    x2: 130,
    y2: 110,
    stroke: "#a78bfa",
    strokeWidth: 2,
    opacity: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 70,
    x2: 200,
    y2: 110,
    stroke: "#a78bfa",
    strokeWidth: 2,
    opacity: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 70,
    x2: 270,
    y2: 110,
    stroke: "#a78bfa",
    strokeWidth: 2,
    opacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 110,
    width: 40,
    height: 40,
    rx: 5,
    fill: "none",
    stroke: "#a78bfa",
    strokeWidth: 2
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 135,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#a78bfa"
  }, "AMOUNT")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 110,
    width: 40,
    height: 40,
    rx: 5,
    fill: "none",
    stroke: "#a78bfa",
    strokeWidth: 2
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 135,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#a78bfa"
  }, "MERCHANT")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 110,
    width: 40,
    height: 40,
    rx: 5,
    fill: "none",
    stroke: "#a78bfa",
    strokeWidth: 2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 270,
    y: 135,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#a78bfa"
  }, "VENDOR")), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 150,
    x2: 110,
    y2: 180,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 150,
    x2: 150,
    y2: 180,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 150,
    x2: 180,
    y2: 180,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 150,
    x2: 220,
    y2: 180,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 270,
    y1: 150,
    x2: 250,
    y2: 180,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 270,
    y1: 150,
    x2: 290,
    y2: 180,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    opacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 190,
    r: 6,
    fill: "#00ff88"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 190,
    r: 6,
    fill: "#ff6b6b"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 190,
    r: 6,
    fill: "#00ff88"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 190,
    r: 6,
    fill: "#ff6b6b"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 190,
    r: 6,
    fill: "#00ff88"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 190,
    r: 6,
    fill: "#ff6b6b"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 220,
    textAnchor: "middle",
    fontSize: 9,
    fill: "#00ff88"
  }, "APPROVE")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 220,
    textAnchor: "middle",
    fontSize: 9,
    fill: "#ff6b6b"
  }, "REJECT")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 220,
    textAnchor: "middle",
    fontSize: 9,
    fill: "#00ff88"
  }, "APPROVE")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 220,
    textAnchor: "middle",
    fontSize: 9,
    fill: "#ff6b6b"
  }, "REVIEW")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 220,
    textAnchor: "middle",
    fontSize: 9,
    fill: "#00ff88"
  }, "APPROVE")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 220,
    textAnchor: "middle",
    fontSize: 9,
    fill: "#ff6b6b"
  }, "BLOCK")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 270,
    textAnchor: "middle",
    fontSize: 12,
    fill: "#a78bfa",
    fontWeight: "bold"
  }, "Real-time Decision Engine \u2022 Sub-millisecond Latency")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSherlocRuleEngine);
export default __webpack_public_path__ + "static/media/sherloc_rule_engine.2e113c5626a7e49c377bc64d99e28fc9.svg";
export { ForwardRef as ReactComponent };